import z from 'zod'

/** Default duration when the dashboard triggers “Show me” on a player. */
export const SHOW_ME_OVERLAY_DEFAULT_DURATION_SECONDS = 15

/**
 * WebSocket payload: `show-me` command from tenant DO → player.
 * Player shows a fullscreen overlay with `title` for `durationSeconds`.
 */
export const showMeOverlayWsPayloadSchema = z.object({
  title: z.string().min(1).max(256),
  durationSeconds: z.number().int().min(1).max(120)
})

export type TShowMeOverlayWsPayload = z.infer<typeof showMeOverlayWsPayloadSchema>
